export const sPageview = () => {
  window.snaptr?.("track", "PageView");
};
